<template>
    <div class="tab-menu-wrap">
        <ul class="tab-menu">
            <li :class="{'tab-menu__item': true, 'active': mode == 'getDepartment'}" @click="switchView('getDepartment')"><a href="javascript:;">Center Introduction</a></li>
            <li :class="{'tab-menu__item': true, 'active': mode == 'getDoctorList'}" @click="switchView('getDoctorList')"><a href="javascript:;">Medical Staff</a></li>
            <li :class="{'tab-menu__item': true, 'active': mode == 'getLocation'}" @click="switchView('getLocation')" v-if=" $store.getters.getHost != 'H0009'"><a href="javascript:;">Location and Direction</a></li>
        </ul>
    </div>
    <div class="about" v-if="mode == 'getDepartment'">
        <div class="about__img">
            <swiper :pagination="true"  :modules="modules" :effect="'fade'" :autoplay="{ delay: 4000 }" :speed="500" class="subSwiper">
                <swiper-slide v-if="org && org[1] && $store.getters.getHost == 'H0008'">
                    <img :src="`/displayFile.do?attachNo=${org[1].attachNo}`" :alt="org[1].altValue || '이미지'">
                </swiper-slide>
                <swiper-slide v-if="org">
                    <img :src="`/displayFile.do?attachNo=${org[0].attachNo}`" :alt="org[0].altValue || '이미지'" >
                </swiper-slide>
            </swiper>
            <p class="about__line-text"></p>
        </div>
        <div class="about__text">
            <p class="about__desc" v-html="contents"></p>
        </div>
        <!-- <kr_QuickMenu :info="info"/> -->
    </div>

    <div class="contents" v-if="mode == 'getDoctorList'">
        <en_DoctorCard :doctorList="doctorList"/>
    </div>

    <template v-if="mode == 'getLocation'">
        <div class="position" v-for="item in location" :key="item">
            <div class="position__text">
                <h3>{{item.floor ? item.floor : ''}}</h3>
            </div>
            <div class="position__map">
                <!-- <img src="@/assets/resource/img/position_map.png" alt="3층 안내도"> -->
                <img :src="`/displayFile.do?attachNo=${item.attachBag.lookAroundPhoto[0].attachNo}`" :alt="item.attachBag.lookAroundPhoto[0].altValue" v-if="item.attachBag.lookAroundPhoto">
            </div>
        </div>
    </template>
    <kr_QuickMenu :info="info"/>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination, Mousewheel, Keyboard, Autoplay, EffectFade } from 'swiper/modules';

export default{
    components: {
        Swiper,
        SwiperSlide,
    },
    setup() {
        return {
            modules: [Navigation, Pagination, Mousewheel, Keyboard, Autoplay, EffectFade],
        };
    },
    data() {
        return {
            mode: 'getDepartment',
            deptCd: this.$route.query.deptCd || '',
            // 센터
            info: '',
            contents: '',
            // 의료진
            doctorList: '',
            // 위치안내
            location: [],
            floor: '',
            // 단체이미지
            org: '',
        }
    },
    methods: {
        switchView(mode){
            this.mode = mode
            // this[mode]()
        },
        getDepartment(){
            const param = {
                hospId: this.$store.getters.getHost,
                deptCd: this.deptCd,
                langCd: this.$store.getters.getLang
            }
            this.axios.get(this.api.department.view, {params: param})
            .then(res => {
                this.info = res.data
                this.org = this.info?.orgAttach?.organizationImg
                this.contents = ''
                if(this.$store.getters.getHost != 'H0006' && res.data.deptInfo) this.contents = res.data.deptInfoGlb + '<br><br>'
                if(res.data?.deptDetailList?.length > 0) this.contents += res.data.deptDetailList[0].contents
            })
        },
        getDoctorList(){
            const param = {
                startIndex: 1,
                pageRow: 999,
                langCd: this.$store.getters.getLang,
                hospId: this.$store.getters.getHost,
                deptCd: this.deptCd,
                orderType: 'deptSort',
                // deptType: 1
            }
            this.axios.get(this.api.doctor.doctorList, {params: param})
            .then(res => {
                if(res.data.doctorTotCnt > 0){
                    this.doctorList = res.data.doctorList
                }

                // if(this.deptCd === 'mom001'){
                //     const hanyejin = {
                //         drName: '한예진',
                //         drNameGlb: '한예진',
                //         belong: '소아청소년과, 고위험 신생아 집중치료센터',
                //         belongGlb: '소아청소년과, 고위험 신생아 집중치료센터',
                //         drSid: 'TEMP001',
                //         deptCd: 'mom001',
                //         mainDeptCd: 'mom001',
                //         detailField: '소아청소년과 일반진료',
                //         img: 'none',
                //         staticData: true
                //     }

                //     this.doctorList.push(hanyejin)
                // }

              if(this.deptCd === 'mom04'){
                const leehyunah = {
                  drName: '이현아',
                  img: 'lha',
                  staticData: true
                }

                this.doctorList.push(leehyunah)
              }

                // 혈액암가족돌봄센터
                if(this.deptCd === 'HEMO'){
                    const docList = [
                        {name: 'JIN JOO YOUN', drNameGlb: 'JIN JOO YOUN', belong: 'Head of the Blood Cancer Department', belongGlb: 'Head of the Blood Cancer Department', detailField: '', imageSrc: 'doctor-blood10.png' },
                        {name: 'KIM HYUN HEE', drNameGlb: 'KIM HYUN HEE', belong: 'Social Work Department', belongGlb: 'Social Work Department', detailField: '', imageSrc: 'doctor-blood17.png'},
                        {name: 'JU YEJIN', drNameGlb: 'JU YEJIN', belong: 'Social Work Department', belongGlb: 'Social Work Department', detailField: '', imageSrc: 'doctor-blood18.png'},
                        {name: 'Jung Hyangju', drNameGlb: 'Jung Hyangju', belong: 'Hematopoietic Stem Cell Transplant Coordinator', belongGlb: 'Hematopoietic Stem Cell Transplant Coordinator', detailField: '', imageSrc: 'doctor-blood09.png' },
                        {name: 'AN SOYEON', drNameGlb: 'AN SOYEON', belong: 'Dedicated Nurse', belongGlb: 'Dedicated Nurse', detailField: '', imageSrc: 'doctor-blood-new03.png' },
                        {name: 'JEON HEEWON', drNameGlb: 'JEON HEEWON', belong: 'Dedicated Nurse', belongGlb: 'Dedicated Nurse', detailField: '', imageSrc: 'doctor-blood-new02.png' },
                        {name: 'SA JI SUN', drNameGlb: 'SA JI SUN', belong: 'Nutritionist', belongGlb: 'Nutritionist', detailField: '', imageSrc: 'doctor-blood20.png' },
                        {name: 'Ko HYO WON', drNameGlb: 'Ko HYO WON', belong: 'Nutritionist', belongGlb: 'Nutritionist', detailField: '', imageSrc: 'doctor-blood21.png' }
                    ]
                    this.doctorList = this.doctorList.concat(docList)
                }
                // 혈액암가족돌봄센터
                if(this.deptCd === 'BHL'){
                    const docList = [
                        {name: 'EUN JEE KIM', drNameGlb: 'EUN JEE KIM', belong: 'Research Nurse', belongGlb: 'Research Nurse', detailField: '', imageSrc: ''},
                        {name: 'YeungIm Yoo', drNameGlb: 'YeungIm Yoo', belong: 'Research Nurse', belongGlb: 'Research Nurse', detailField: '', imageSrc: ''},
                        {name: 'HYOUN JUNG LEE', drNameGlb: 'HYOUN JUNG LEE', belong: 'Research Nurse', belongGlb: 'Research Nurse', detailField: '', imageSrc: ''},
                        {name: 'Ahn Jeeyoung', drNameGlb: 'Ahn Jeeyoung', belong: 'Researcher', belongGlb: 'Researcher', detailField: '', imageSrc: ''},
                        {name: 'Lee Seong-kyung', drNameGlb: 'Lee Seong-kyung', belong: 'Researcher', belongGlb: 'Researcher', detailField: '', imageSrc: ''}
                    ]
                    this.doctorList = this.doctorList.concat(docList)
                }

            })
        },
        getLocation(){
            const param = {
                deptCd: this.deptCd
            }
            this.axios.get(this.api.lookAround.deptLookAround, {params: param})
            .then(res => {
                this.location = []
                if(res.data?.length > 0) {
                    const list = res.data
                    for(let i of list){
                        if(i.parentPlaceNm == '영문'){
                            this.location.push(i)
                        }
                    }
                    this.floor = res.data[0].floor
                    
                    const floorSort = (floor) => {
                        if (floor.startsWith('B')) {
                            return -parseInt(floor.substring(1))
                        }
                        if (floor.startsWith('F')) {
                            return parseInt(floor.substring(1))
                        }
                        return 0
                    }

                    this.location.sort(function(a, b) {
                        return floorSort(a.floor) - floorSort(b.floor);
                    })
                }
            })
        }
    },
    mounted() {
        if(!this.deptCd){
            alert("잘못된 접근입니다.")
            this.$router.push('/')
            return
        }
        
        this.getDepartment()
        this.getDoctorList()
        if(this.$store.getters.getHost != 'H0009') this.getLocation()
    },
    watch: {
        $route(to, from){
            if(to.path == from.path){
                this.mode = 'getDepartment'
                this.deptCd = to.query.deptCd,
                this.getDepartment()
                this.getDoctorList()
                if(this.$store.getters.getHost != 'H0009') this.getLocation()
            }
        }
    },
}
</script>